import { MouseEvent, ReactNode } from 'react';
import clsx from 'clsx';

import { eventService, XApiEventKeys } from 'shared/api/event-service';
import { PAGES } from 'shared/config/constants';
import { getAmpConfig } from 'shared/config/amp-config';

import styles from './styles.module.scss';

type QuickLinksItemProps = {
  linkName: string;
  linkHref: string;
  children: ReactNode;
};

export const QuickLinksItem = ({
  children,
  linkName,
  linkHref,
}: QuickLinksItemProps) => {
  const handleXApiEvent = (isRightClick = false) => {
    const destinationUrl = linkHref.endsWith(PAGES.SCHEDULED)
      ? `${getAmpConfig().educatorHome}/#/scheduled`
      : linkHref;

    return eventService.send(
      XApiEventKeys.selectedQuickLink,
      {
        result: {
          destinationUrl,
        },
      },
      {
        result: {
          quickLinkName: linkName,
          isRightClick,
        },
      },
    );
  };

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();

    handleXApiEvent().finally(() => {
      window.location.assign(linkHref);
    });
  };

  const handleContextMenu = () => handleXApiEvent(true);

  return (
    <li className={styles.quickLinksItem}>
      <a
        href={linkHref}
        className={styles.quickLink}
        onClick={handleClick}
        onContextMenu={handleContextMenu}
      >
        <span className={styles.iconWrapper}>{children}</span>
        <span className={styles.linkName}>{linkName}</span>
        <i
          className={clsx('icon-v2-arrow-next', styles.arrowIcon)}
          aria-hidden
        />
      </a>
    </li>
  );
};
